<template>
  <div
    class="managePage"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.4)"
  >
    <div class="card_wrap">
      <div class="card_list flex-rowl" v-if="menuList.length > 0">
        <div class="card_item" v-for="item in menuList" :key="item.id">
          <div class="tit flex-rowl">
            <el-image
              style="width: 32px"
              :src="item.icon"
              fit="contain"
            ></el-image>
            <p>{{ item.funcname }}</p>
          </div>
          <div class="main">
            <div
              class="link"
              v-for="itemChild in item.two_authority"
              :key="itemChild.id"
            >
              <p @click="handleGo(item, itemChild, itemChild.pagepath)">
                {{ itemChild.funcname }} →
              </p>
            </div>
          </div>
        </div>
      </div>
      <el-empty description="暂无" v-else></el-empty>
    </div>
  </div>
</template>
<script>
import { getMenuAuthOne } from "../api/api";
export default {
  name: "manage",
  data() {
    return {
      loading: false,
      menuList: [],
    };
  },
  created() {
    this.getMenuAuthOne();
  },

  methods: {
    getMenuAuthOne() {
      this.loading = true
      getMenuAuthOne().then((res) => {
        this.menuList = this.filterMenu(res);
         this.loading = false
      });
    },
    // 过滤菜单栏
    filterMenu(menuList) {
      let roleId = this.$store.state.USERINFO.qy.roleid;
      return menuList
        .filter((item) => {
          return item.viewrange.split(",").indexOf(roleId) > -1;
        })
        .map((item) => {
          item = Object.assign({}, item);
          if (item.two_authority) {
            item.two_authority = this.filterMenu(item.two_authority);
          }
          return item;
        });
    },

    handleGo(item, itemChild, path) {
      console.log(item, "======");
      // 判断是否有操作权限
      let roleId = this.$store.state.USERINFO.qy.roleid;
      if (itemChild.dorange.split(",").indexOf(roleId) == -1) {
        this.$message.warning("暂无操作权限");
        return;
      }
      if (path) {
        this.$store.commit("setMenuList", itemChild);
        this.$router.push(path);
      } else {
        this.$message.warning("即将开放");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.managePage {
  min-height: 100vh;
  padding: 150px 0;
  box-sizing: border-box;
  .card_wrap {
    padding: 30px 65px 0;
    font-size: 24px;
    color: #444444;
    .card_list {
      flex-wrap: wrap;
      align-items: flex-start;
      .card_item {
        flex-shrink: 0;
        width: calc((100% - 28px) / 2);
        padding: 55px 0 60px 45px;
        // height: 160px;
        background: #fbfbfb;
        box-shadow: 0px 0 7px 0px rgba(84, 79, 90, 0.1),
          0px -6px 0px 0px #6f5d88;
        //   box-shadow: 0px 0px 7px 0px rgba(84, 79, 90, 0.1), 0px 6px 0px 0px #6f5d88;
        border-radius: 30px;
        box-sizing: border-box;
        margin-right: 28px;
        margin-bottom: 30px;
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
      .tit {
        margin-bottom: 20px;
        p {
          margin-left: 20px;
        }
      }
      .main {
        margin-left: 56px;
        font-size: 24px;
        color: #444444;
        .link {
          margin-bottom: 15px;
          p {
            font-size: 16px;
            line-height: 25px;
            cursor: pointer;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>